// extracted by mini-css-extract-plugin
export default {"title":"styles_title__wPLmp","spin":"styles_spin__T2iD7"};